export default {
  home: {
    id: 'landing_breadcrumb_home',
    defaultMessage: 'Home',
  },
}
